export const SYNC_OFFSET_STEP_SECONDS = 0.5;
export const MAX_SYNC_OFFSET_SECONDS = 30;
const RETRY_DELAYS_MS = [250, 750];

export function adjustSyncOffset(current: number, direction: -1 | 1): number {
  const adjusted = current + direction * SYNC_OFFSET_STEP_SECONDS;
  const clamped = Math.min(MAX_SYNC_OFFSET_SECONDS, Math.max(-MAX_SYNC_OFFSET_SECONDS, adjusted));
  return Math.round(clamped * 2) / 2;
}

export function adjustedTimestamp(timestamp: number, syncOffsetSeconds: number): number {
  return timestamp - syncOffsetSeconds;
}

export function getSyncSaveErrorMessage(error: unknown): string {
  const status = getErrorStatus(error);
  switch (status) {
    case 401:
      return "Sync changed locally, but the server did not recognize this session (401).";
    case 404:
      return "Sync changed locally, but the save endpoint is unavailable (404).";
    case 409:
      return "Sync changed locally, but the lyrics cache is not ready (409).";
    case 500:
      return "Sync changed locally, but the database save failed (500).";
    default:
      return status === undefined
        ? "Sync changed locally, but it could not be saved."
        : `Sync changed locally, but it could not be saved (HTTP ${status}).`;
  }
}

export async function saveSyncOffsetWithRetry(
  save: () => Promise<void>,
  wait: (delayMs: number) => Promise<void> = delay
): Promise<void> {
  for (let attempt = 0; attempt <= RETRY_DELAYS_MS.length; attempt += 1) {
    try {
      await save();
      return;
    } catch (error) {
      const status = getErrorStatus(error);
      if (status !== 409 || attempt === RETRY_DELAYS_MS.length) {
        throw error;
      }
      await wait(RETRY_DELAYS_MS[attempt]);
    }
  }
}

function getErrorStatus(error: unknown): number | undefined {
  if (error !== null && typeof error === "object" && "status" in error) {
    const status = (error as { status?: unknown }).status;
    return typeof status === "number" ? status : undefined;
  }
  return undefined;
}

function delay(delayMs: number): Promise<void> {
  return new Promise(resolve => window.setTimeout(resolve, delayMs));
}
